
import OrdersTypeList from './list.vue'
import OrdersTypeEdit from "./edit.vue";

let a = Object.assign({OrdersTypeList,OrdersTypeEdit});
export default a;